import { z } from 'zod';
export const capabilityLevelSchema = z.enum([
    'not_introduced',
    'introduced',
    'practised_with_guidance',
    'demonstrated_with_assistance',
    'demonstrated_independently',
    'demonstrated_under_pressure',
    'transfer_demonstrated',
]);
export const programModuleSchema = z.object({
    number: z.number().int().min(1),
    title: z.string(),
    durationDays: z.number().int().positive(),
    outcome: z.string(),
    topics: z.array(z.string()),
});
export const programSchema = z.object({
    id: z.string(),
    title: z.string(),
    totalWeeks: z.number().int().min(1),
    hoursPerDay: z.tuple([z.number(), z.number()]),
    modules: z.array(programModuleSchema),
});
